import Alpine from "alpinejs";
import { cart } from "./store-cart";
import {
  cartRecommendations,
  cartRecommendation,
} from "./module-recommendations";
import { freeGiftTrack } from "./module-free-gift-track";
import { Product } from "./module-product";
import { Localization } from "./module-localization";

// Stores
Alpine.store("cart", cart);
Alpine.data("cartRecommendations", cartRecommendations);
Alpine.data("cartRecommendation", cartRecommendation);
Alpine.data("freeGiftTrack", freeGiftTrack);
Alpine.data("product", Product);
Alpine.data("localization", Localization);

// Init
window.Alpine = Alpine;
Alpine.start();
